import React, { Suspense, useEffect, useState } from 'react';
import {
  Button,
  Divider,
  Grid,
  Image,
  Layout,
  Modal,
  Space,
  Spin,
  Tooltip,
  Typography,
} from 'antd';
import {
  DownOutlined,
  LeftCircleOutlined,
  MenuFoldOutlined,
  MenuOutlined,
  RightCircleOutlined,
} from '@ant-design/icons';
import styled from 'styled-components';
import UserAvatar from '../../components/UserAvatar';
import useConfigApp from '../../hooks/useConfigApp';
import AppLogo from '../../components/AppLogo';
import Breadcrumbs from '../../components/Breadcrumbs';
import Sidebar from '../../components/Sidebar';
import { Outlet, useLocation, useNavigate } from 'react-router-dom';
import { theme } from '../../assets/theme';
import { useAuthUser, useSignOut } from 'react-auth-kit';
import { httpRequest } from '../../helpers/api';
import {
  MainCheckHealth,
  IdleHandler,
  thisYear,
} from '@qlibs/react-components';
import { MENUS_FLAT } from '../../const/menu';
import config, {
  APP_THEME,
  APP_VERSION,
  CURRENT_APP_THEME,
} from '../../const/config';
import { isMobile as isMobileDevice } from 'react-device-detect';
import useGroup from '../../zustand/useGroup';
import ActionApplication from '../../components/ActionApplication';
import TimezoneSelector from '../../components/TimezoneSelector';

const { Header, Sider, Content } = Layout;

const AppLayout = () => {
  const screens = Grid.useBreakpoint();
  const navigate = useNavigate();
  const { sidebarCollapsed, toggleSidebar } = useConfigApp();
  const location = useLocation();
  const auth = useAuthUser();
  const signOut = useSignOut();
  const [sidebarShow, setSidebarShow] = useState(isMobileDevice ? false : true);

  const { feature } = useGroup();

  const pathname = location.pathname;
  const isGroupResponsivePage = pathname.startsWith('/group');
  const isCompanyResponsivePage = pathname.startsWith('/company');
  const isAssetResponsivePage = pathname.startsWith('/asset');
  const isDeviceResponsivePage = pathname.startsWith('/device');
  const isOperationModeResponsivePage = pathname.startsWith('/operation-mode');
  const isMasterReportResponsivePage = pathname.startsWith('/master-report');
  const isAdminResponsivePage = pathname.startsWith('/admin');
  const isRoleResponsivePage = pathname.startsWith('/role');
  const isEntityResponsivePage =
    isGroupResponsivePage ||
    isCompanyResponsivePage ||
    isAssetResponsivePage ||
    isDeviceResponsivePage ||
    isOperationModeResponsivePage ||
    isMasterReportResponsivePage ||
    isAdminResponsivePage ||
    isRoleResponsivePage;
  const isResponsivePage =
    ['/home', '/dashboard', '/report-log'].includes(pathname) ||
    isEntityResponsivePage;
  const isNarrowViewport = screens.md === false;
  const isCompactLayout =
    isMobileDevice || (isResponsivePage && isNarrowViewport);
  const showHeaderDetails = !isResponsivePage || !isCompactLayout;
  const showApplicationDropdown = showHeaderDetails && !isCompactLayout;

  useEffect(() => {
    if (isResponsivePage && (!isEntityResponsivePage || isCompactLayout)) {
      setSidebarShow(!isCompactLayout);
    }
  }, [isCompactLayout, isEntityResponsivePage, isResponsivePage]);

  useEffect(() => {
    if (isMobileDevice || screens.md === false) {
      setSidebarShow(false);
    }
  }, [pathname, screens.md]);

  useEffect(() => {
    if (pathname.includes('/home')) {
      toggleSidebar(true);
    } else {
      toggleSidebar(false);
    }
  }, [pathname]);

  return (
    <>
      <div>
        {/* {!!process.env.REACT_APP_CHECK_HEALTH_URL && (
          <MainCheckHealth
            url={process.env.REACT_APP_CHECK_HEALTH_URL || '/'}
            axiosInstance={httpRequest as any}
          />
        )} */}
        {/* <IdleHandler
          pingUrl={process.env.REACT_APP_CHECK_HEALTH_URL || '/'}
          axiosInstance={httpRequest as any}
          isLoggedIn={auth() ? true : false}
          idleTimeout={undefined}
          sessionTimeout={undefined}
          callbackOnError={() => {
            signOut();
            navigate('/login');
          }}
        >
          {' '}
        </IdleHandler> */}
      </div>
      <Layout
        className="theme-1"
        style={{ height: '100vh', flexDirection: 'row' }}
      >
        {sidebarShow && (
          <AppSider
            $compact={isCompactLayout}
            onCollapse={toggleSidebar}
            trigger={null}
            collapsible
            collapsed={isCompactLayout ? false : sidebarCollapsed}
            collapsedWidth={70}
            width={240}
            style={{
              paddingLeft: 0,
              height: '100vh',
            }}
          >
            <AppLogo collapsed={isCompactLayout ? false : sidebarCollapsed} />
            <Sidebar collapsed={isCompactLayout ? false : sidebarCollapsed} />
          </AppSider>
        )}
        {sidebarShow && isCompactLayout && (
          <SidebarBackdrop onClick={() => setSidebarShow(false)} />
        )}
        {sidebarShow && !isCompactLayout && sidebarCollapsed ? (
          <Tooltip placement="right" title={'Expand Sidebar'}>
            <Button
              style={{
                position: 'absolute',
                bottom: 0,
                height: 40,
                width: 70,
                backgroundColor:
                process.env.REACT_APP_THEME === 'arnantara'
                  ? '#000000'
                  : process.env.REACT_APP_THEME === 'netra'
                    ? '#f3f4f6'
                    : process.env.REACT_APP_THEME === 'bki'
                      ? '#062c47'
                      : '#2b2b2b',
              }}
              onClick={() => toggleSidebar()}
              type="text"
              icon={
                <RightCircleOutlined
                  style={{ color: theme.colors.white }}
                  className="icon-collapsed"
                />
              }
            />
          </Tooltip>
        ) : sidebarShow && !isCompactLayout ? (
          <MinimizeButton
            onClick={() => {
              if (!isCompactLayout) {
                toggleSidebar();
              }
            }}
            className="minimize-container"
          >
            <div>
              v{APP_VERSION} · ©{thisYear}
            </div>
            {!isCompactLayout && (
              <LeftCircleOutlined style={{ color: 'white !important' }} />
            )}
          </MinimizeButton>
        ) : (
          false
        )}

        <Layout
          id="scroll-content"
          className="site-layout"
          style={{ minHeight: '100vh', overflowY: 'scroll' }}
        >
          <AppHeader $compact={isCompactLayout}>
            {isCompactLayout && sidebarShow ? (
              <span
                style={{ cursor: 'pointer', padding: 5 }}
                onClick={() => setSidebarShow(false)}
              >
                <MenuFoldOutlined style={{ fontSize: 20 }} />
              </span>
            ) : isCompactLayout ? (
              <span
                style={{ cursor: 'pointer', padding: 5 }}
                onClick={() => setSidebarShow(true)}
              >
                <MenuOutlined style={{ fontSize: 20 }} />
              </span>
            ) : (
              false
            )}
            {isCompactLayout && <MobileHeaderLogo />}
            {config.pageTitlePosition === 'top-nav' &&
              !isCompactLayout &&
              MENUS_FLAT.map((item: any) => {
                if (item.key === location.pathname) {
                  return (
                    <>
                      <AppHeaderLabel>
                        {item.icon}
                        <Typography.Title
                          level={3}
                          style={{ marginBottom: 0, fontSize: 18 }}
                        >
                          {item.label}
                        </Typography.Title>
                        <Divider type="vertical" />
                        <Typography.Text style={{ color: 'darkgrey' }}>
                          {item.description}
                        </Typography.Text>
                      </AppHeaderLabel>
                    </>
                  );
                } else {
                  return false;
                }
              })}

            {config.pageTitlePosition === 'content' && !isCompactLayout && (
              <Breadcrumbs />
            )}

            <AppHeaderAccount $compact={isCompactLayout}>
              {showHeaderDetails && config.topNav.showWelcomeName && (
                <DateNow>
                  Welcome, <b>{auth()?.firstName || auth()?.name}</b>
                  <small>
                    (<i>{auth()?.role.roleName}</i>)
                  </small>
                </DateNow>
              )}
              {!isCompactLayout && <DividerTitle />}

              {showApplicationDropdown && <ActionApplication />}

              {(['/report-log', '/dashboard'].includes(pathname) ||
                isMasterReportResponsivePage) && <TimezoneSelector />}

              <UserAvatar compact={isCompactLayout} />
            </AppHeaderAccount>
          </AppHeader>

          <AppContent pathname={pathname}>
            <Space size="middle" direction="vertical">
              {config.pageTitlePosition === 'top-nav' && (
                <Breadcrumbs marginTop={10} />
              )}

              <Suspense
                fallback={
                  pathname === '/dashboard' && isCompactLayout ? (
                    <MobileRouteLoading>
                      <Spin spinning={true} />
                    </MobileRouteLoading>
                  ) : (
                    <Spin spinning={true} />
                  )
                }
              >
                <Outlet />
              </Suspense>
            </Space>

            {/* {!['/home', '/report-log', '/device'].includes(pathname) && (
              <div style={{ height: 100 }}></div>
            )} */}
          </AppContent>
        </Layout>

        {/* <TawkMessengerReact
          propertyId="65a62d590ff6374032c0c3ea"
          widgetId="1hk8i29gf"
        /> */}
      </Layout>
    </>
  );
};

const AppContent = styled(Content)<{ pathname: string }>`
  height: 100%;
  padding: ${(props) => (props.pathname === '/home' ? '0 !important' : '10px')};
  padding-right: ${(props) =>
    props.pathname === '/home' ? '0 !important' : '5px'};
  overflow: ${(props) => (props.pathname === '/home' ? 'hidden' : 'auto')};

  ${(props) =>
    props.pathname === '/home' &&
    `
      > .ant-space,
      > .ant-space > .ant-space-item {
        width: 100%;
        min-width: 0;
      }
    `}

  @media (max-width: 767px) {
    ${(props) =>
      props.pathname === '/dashboard' &&
      `
        padding: 0 !important;
        overflow-x: hidden;

        > .ant-space,
        > .ant-space > .ant-space-item {
          width: 100%;
          min-width: 0;
        }
      `}
  }
`;

const MobileRouteLoading = styled.div`
  width: 100%;
  min-height: calc(100dvh - 60px);
  display: grid;
  place-items: center;
  background: #f4f6f9;
`;

const AppSider = styled(Sider)<{ $compact: boolean }>`
  background-color: ${({ theme }) => theme.colors.primary};
  overflow: auto;
  overflow-x: hidden;
  padding-left: 10px;

  ${({ $compact }) =>
    $compact &&
    `
      position: fixed !important;
      inset: 0 auto 0 0;
      z-index: 2001;
      box-shadow: 6px 0 18px rgba(0, 0, 0, 0.24);
    `}
`;

const SidebarBackdrop = styled.div`
  position: fixed;
  inset: 0;
  z-index: 2000;
  background: rgba(0, 0, 0, 0.36);
`;

const AppHeader = styled(Header)<{ $compact: boolean }>`
  background-color: var(--primary-3);
  position: sticky;
  top: 0;
  padding: ${({ $compact }) => ($compact ? '0 12px' : '0 20px')};
  height: ${({ $compact }) => ($compact ? '70px' : '60px')};;
  display: ${({ $compact }) => ($compact ? 'grid' : 'flex')};
  ${({ $compact }) =>
    $compact && 'grid-template-columns: 40px minmax(0, 1fr) auto;'}
  justify-content: space-between;
  align-items: center;
  gap: 8px;
  z-index: 50;
`;

const MobileHeaderLogo = () => (
  <MobileHeaderLogoWrapper>
    <Image
      preview={false}
      src={
        APP_THEME === CURRENT_APP_THEME.ARNANTARA
          ? '/arnantara-logo-only.png'
          : APP_THEME === CURRENT_APP_THEME.BKI
          ? '/bki-logo-white.png'
          : APP_THEME === CURRENT_APP_THEME.NETRA
            ? '/netra-logo.png'
            : APP_THEME === CURRENT_APP_THEME.PINISI
              ? '/pinisi-logo-white.png'
              : '/ramus-logo.svg'
      }
    />
  </MobileHeaderLogoWrapper>
);

const MobileHeaderLogoWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  min-width: 0;

  .ant-image,
  img {
    display: block;
    width: 105px !important;
    max-width: 100%;
    height: auto;
    object-fit: contain;
  }
`;

const DateNow = styled.div`
  color: ${({ theme }) => theme.colors.black};
  text-align: right;
`;

const AppHeaderAccount = styled.div<{ $compact: boolean }>`
  flex: 1;
  display: grid;
  gap: 8px;
  grid-template-columns: ${({ $compact }) =>
    $compact ? 'minmax(0, 1fr)' : '1fr auto auto auto'};
  align-items: center;
  justify-content: flex-end;
  justify-items: ${({ $compact }) => ($compact ? 'end' : 'stretch')};

  ${({ $compact }) =>
    $compact &&
    `
      grid-auto-flow: column;

      > div:last-child {
        width: auto !important;
        margin-left: auto;
      }
    `}
`;

const AppHeaderLabel = styled.div`
  display: flex;
  gap: 8px;
  align-items: center;
`;

const DividerTitle = styled.div`
  width: 2.5px;
  height: 100%;
  background-color: #eef0f6;
  opacity: 0.4;
  margin: 0 10px;
`;

const MinimizeButton = styled.div`
  background-color: ${({ theme }) => theme.colors.primary};
  width: 100%;
  display: flex;
  height: 60px;
  align-items: center;
  justify-content: space-between;
  padding: 0px 16px;
  cursor: pointer;

  div {
    color: ${({ theme }) => 'white'};
    font-size: 10px;
  }

  svg {
    fill: ${({ theme }) => 'white'};
  }
`;

export default AppLayout;
